import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request';
import {CompleteFormData} from '../types';

export type ProfileSetupSuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessStatusMessage>;

export type ProfileSetupErrorResponse = Api.Response.Failure;

export const usePostProfileSetup = (
    mid: string,
): UseMutationResult<
    ProfileSetupSuccessResponse,
    ProfileSetupErrorResponse,
    CompleteFormData
> => {
    const locale = useLocale();

    return useMutation((formData) =>
        request({
            formData,
            locale,
            method: 'POST',
            uri: `/api/partner/${mid}/signup/update/`,
        }),
    );
};
